/* Raizelle – scripts de las secciones propias (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal al hacer scroll (un solo observer) ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.rz-reveal:not(.rz-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('rz-visible'); });
      return;
    }
    if (!window.__rzRevealObserver) {
      window.__rzRevealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('rz-visible'); window.__rzRevealObserver.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    els.forEach(function (e) { window.__rzRevealObserver.observe(e); });
  }

  /* ---------- Contador "evergreen" (se reinicia por visitante) ---------- */
  function initCountdown() {
    document.querySelectorAll('[data-rz-countdown]').forEach(function (bar) {
      if (bar.__rzInit) return; bar.__rzInit = true;
      var hours = parseFloat(bar.getAttribute('data-hours') || '6');
      var key = 'rz_countdown_end_' + (bar.getAttribute('data-key') || 'oferta');
      var end = 0;
      try { end = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) {}
      var now = Date.now();
      if (!end || end < now) {
        end = now + hours * 3600 * 1000;
        try { localStorage.setItem(key, String(end)); } catch (e) {}
      }
      var dEl = bar.querySelector('[data-unit="days"]');
      var hEl = bar.querySelector('[data-unit="hours"]');
      var mEl = bar.querySelector('[data-unit="mins"]');
      var sEl = bar.querySelector('[data-unit="secs"]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = Math.max(0, end - Date.now());
        if (diff === 0) { end = Date.now() + hours * 3600 * 1000; try { localStorage.setItem(key, String(end)); } catch (e) {} diff = end - Date.now(); }
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        if (dEl) dEl.textContent = pad(d);
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
      var close = bar.querySelector('[data-rz-close]');
      if (close) close.addEventListener('click', function () {
        bar.setAttribute('data-hidden', 'true');
        try { sessionStorage.setItem('rz_countdown_closed', '1'); } catch (e) {}
      });
      try { if (sessionStorage.getItem('rz_countdown_closed') === '1') bar.setAttribute('data-hidden', 'true'); } catch (e) {}
    });
  }

  /* ---------- Ofertas (1 / 2 / 3 unidades): sincroniza la cantidad del formulario ---------- */
  function findProductForm(el) {
    var section = el.closest('.shopify-section') || document;
    return section.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  }
  function setFormQuantity(el, qty) {
    var form = findProductForm(el);
    if (!form) return;
    var input = form.querySelector('input[name="quantity"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'quantity';
      form.appendChild(input);
    }
    input.value = qty;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function initOffers() {
    document.querySelectorAll('[data-rz-offers]').forEach(function (box) {
      if (box.__rzInit) return; box.__rzInit = true;
      var offers = box.querySelectorAll('.rz-offer');
      function select(offer) {
        offers.forEach(function (o) { o.setAttribute('data-selected', o === offer ? 'true' : 'false'); });
        var input = offer.querySelector('input'); if (input) input.checked = true;
        setFormQuantity(box, parseInt(offer.getAttribute('data-qty') || '1', 10));
      }
      offers.forEach(function (o) {
        o.addEventListener('click', function () { select(o); });
      });
      var initial = box.querySelector('.rz-offer[data-selected="true"]') || offers[0];
      if (initial) select(initial);
      // Si Horizon vuelve a pintar el formulario (cambio de variante), re-aplicamos la cantidad
      var form = findProductForm(box);
      if (form) form.addEventListener('submit', function () {
        var sel = box.querySelector('.rz-offer[data-selected="true"]');
        if (sel) setFormQuantity(box, parseInt(sel.getAttribute('data-qty') || '1', 10));
      }, true);
    });
  }


  /* ---------- Colores por unidad en packs (RZ mix) ---------- */
  function initMix() {
    document.querySelectorAll('[data-rz-offers]').forEach(function (box) {
      var mix = box.querySelector('[data-rz-mix]');
      if (!mix || mix.__rzInit) return; mix.__rzInit = true;
      var rows = Array.prototype.slice.call(mix.querySelectorAll('[data-rz-mix-row]'));
      function currentVariant() {
        var f = findProductForm(box); var i = f && f.querySelector('input[name="id"]');
        return i && i.value ? String(i.value) : null;
      }
      function selQty() {
        var s = box.querySelector('.rz-offer[data-selected="true"]');
        return s ? parseInt(s.getAttribute('data-qty') || '1', 10) : 1;
      }
      function setRow(row, id) {
        var ok = false;
        row.querySelectorAll('.rz-mix__opt').forEach(function (b) {
          var on = b.getAttribute('data-variant-id') === id && !b.disabled;
          if (on) ok = true;
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (!ok) { var first = row.querySelector('.rz-mix__opt:not([disabled])'); if (first) { first.setAttribute('aria-pressed', 'true'); id = first.getAttribute('data-variant-id'); } }
        row.__v = id;
      }
      rows.forEach(function (row) {
        row.addEventListener('click', function (e) {
          var b = e.target.closest('.rz-mix__opt'); if (!b || b.disabled) return;
          e.preventDefault(); row.__touched = true; setRow(row, b.getAttribute('data-variant-id'));
        });
      });
      function refresh() {
        var q = selQty(); var cv = currentVariant();
        mix.hidden = false;
        rows.forEach(function (row, idx) {
          var show = idx < q; row.hidden = !show;
          if (!row.__touched && cv) setRow(row, cv);
          else if (!row.__v) setRow(row, cv || '');
        });
      }
      mix.__refresh = refresh;
      mix.__items = function () {
        refresh();
        var q = selQty();
        if (!(q > 0)) q = 1;
        var map = {}, order = [];
        rows.forEach(function (row, idx) {
          if (idx < q && row.__v) { if (!map[row.__v]) { map[row.__v] = 0; order.push(row.__v); } map[row.__v]++; }
        });
        return order.map(function (id) { return { id: parseInt(id, 10), quantity: map[id] }; });
      };
      refresh();
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.rz-offer, variant-picker, [data-variant-picker], .variant-picker, fieldset')) {
      setTimeout(function () { document.querySelectorAll('[data-rz-mix]').forEach(function (m) { if (m.__refresh) m.__refresh(); }); }, 250);
    }
  });
  /* Pack con colores: se arma el carrito y se abre el formulario COD en modo carrito */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#rsi_buy_now_button');
    if (!btn) return;
    if (btn.closest('cart-items-component, cart-drawer-component, .cart-drawer, .cart-drawer__content')) return;
    if (window.__rzBypass) { window.__rzBypass = false; return; }
    var mix = document.querySelector('[data-rz-mix]');
    if (!mix || !mix.__items) return;
    var items = mix.__items();
    if (!items || !items.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    btn.style.opacity = '0.6';
    fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
      .then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add');
        var cb = document.querySelector('cart-items-component #rsi_buy_now_button, .cart-drawer #rsi_buy_now_button, cart-drawer-component #rsi_buy_now_button');
        if (!cb) throw new Error('nocartbtn');
        btn.style.opacity = '';
        cb.click();
      })
      .catch(function () { btn.style.opacity = ''; window.__rzBypass = true; btn.click(); });
  }, true);

  /* ---------- Sliders sencillos (mini reseñas y videos) ---------- */
  function initSliders() {
    document.querySelectorAll('[data-rz-slider]').forEach(function (slider) {
      if (slider.__rzInit) return; slider.__rzInit = true;
      var track = slider.querySelector('[data-rz-track]');
      var items = track ? Array.prototype.slice.call(track.children) : [];
      var dotsWrap = slider.querySelector('[data-rz-dots]');
      var prev = slider.querySelector('[data-rz-prev]');
      var next = slider.querySelector('[data-rz-next]');
      var auto = parseInt(slider.getAttribute('data-autoplay') || '0', 10);
      if (!track || !items.length) return;

      var dots = [];
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        items.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Ir al elemento ' + (i + 1));
          b.addEventListener('click', function () { goTo(i); });
          dotsWrap.appendChild(b); dots.push(b);
        });
      }
      function current() {
        var x = track.scrollLeft, best = 0, bd = Infinity;
        items.forEach(function (it, i) { var d = Math.abs(it.offsetLeft - x); if (d < bd) { bd = d; best = i; } });
        return best;
      }
      function paint() { var c = current(); dots.forEach(function (d, i) { d.setAttribute('aria-current', i === c ? 'true' : 'false'); }); }
      function goTo(i) {
        i = (i + items.length) % items.length;
        track.scrollTo({ left: items[i].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
      if (next) next.addEventListener('click', function () { goTo(current() + 1); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
      paint();
      if (auto > 0 && !reduceMotion) {
        var timer = setInterval(function () { goTo(current() + 1); }, auto);
        slider.addEventListener('pointerenter', function () { clearInterval(timer); });
      }
    });
  }

  /* ---------- Videos: silenciar / activar sonido ---------- */
  function initVideos() {
    document.querySelectorAll('[data-rz-mute]').forEach(function (btn) {
      if (btn.__rzInit) return; btn.__rzInit = true;
      var video = btn.parentElement.querySelector('video');
      if (!video) { btn.remove(); return; }
      btn.addEventListener('click', function () {
        video.muted = !video.muted;
        btn.setAttribute('data-muted', video.muted ? 'true' : 'false');
        if (!video.muted) video.play().catch(function () {});
      });
    });
  }

  function initAll() { initReveal(); initCountdown(); initOffers(); initMix(); initSliders(); initVideos(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  // El editor de Shopify y Horizon re-renderizan secciones: volvemos a inicializar
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
  var mo = new MutationObserver(function () { clearTimeout(window.__rzMoT); window.__rzMoT = setTimeout(initAll, 120); });
  mo.observe(document.body, { childList: true, subtree: true });
})();
